module.exports = __webpack_public_path__ + "img/nofavorites.b7e2d33e.png";